import { useConfigurator } from '@/app/store/configurator/hooks/use-configurator';
import { RACK_MATERIALS_OPTIONS, SHELVE_MATERIALS_LIMITS } from '@/shared/constants/configurator';
import { RackMaterial } from '@/shared/types/configurator';
import { Checkbox } from '@/shared/ui/checkbox/checkbox';
import { LineSelect } from '@/shared/ui/line-select/line-select';
import { useConfiguratorData } from '@/widgets/configurator';
import { useTranslation } from 'react-i18next';
import { MaterialOptions } from '../material-option/material-option';
import { MultiSectionEditor } from '../multi-section-editor/multi-section-editor';
import styles from './toolbar.module.css';

export const Toolbar = () => {
	const { t } = useTranslation();
	const { state, updateOptions } = useConfigurator();
	const { data } = useConfiguratorData();

	const materialOptions = RACK_MATERIALS_OPTIONS.map((option) => ({
		...option,
		label: t(option.label),
	}));

	const handleUpdateMaterial = (material: RackMaterial) => {
		const newSections = state.sections.map((section) => ({
			...section,
			selfs: section.selfs.map((self) => ({
				...self,
				deck: SHELVE_MATERIALS_LIMITS[material][0],
			})),
		}));

		if (data) {
			for (let i = 0; i < newSections.length; i++) {
				if (!data.heights[material].includes(newSections[i].height)) {
					newSections[i].height = data.heights[material][0];
				}
			}
		}

		useConfigurator.setState({
			state: {
				...state,
				material,
				sections: newSections,
			},
		});
	};

	return (
		<div className={styles.wrapper}>
			<LineSelect
				options={materialOptions}
				value={state.material}
				onChange={handleUpdateMaterial}
				render={MaterialOptions}
				className={styles.materialSelect}
			/>
			<MultiSectionEditor />
			<div className={styles.checkboxWrapper}>
				<p className={styles.checkboxLabel}>{t('toolbar.sectionGaps')}:</p>
				<Checkbox
					value={state.wallMounted}
					onChange={(wallMounted) => updateOptions({ wallMounted })}
				/>
			</div>
			<div className={styles.checkboxWrapper}>
				<p className={styles.checkboxLabel}>{t('toolbar.doubleSides')}:</p>
				<Checkbox
					value={state.doubleSided}
					onChange={(doubleSided) => updateOptions({ doubleSided })}
				/>
			</div>
		</div>
	);
};
